        import { Injectable, Inject} from 'ng-metadata/core';

        @Injectable()

        export class UserAreaService{
            private UPDATE_DB_URL: string;

        constructor(@Inject('$http') private $http: ng.IHttpService,
                    @Inject('restBaseURLs') restBaseURLs) {
          this.UPDATE_DB_URL= restBaseURLs.userSettingsBaseURL;      
       }

        private buildPaylod(view, language){
             let payload= {
                   'vid': view,
                   'interface-language':language
             };
             return payload;
        }


        updateUserLanguage(view, language){
            let payload= this.buildPaylod(view, language);
            return this.$http.post(this.UPDATE_DB_URL, payload); 
         }
            
       }





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/userArea.service.ts